import { createSelector } from 'reselect';
import { AppState } from '~/store';
import { RobotTask } from '../types/resources';

/**
 * Finds ids for robots that have new robot.yaml tasks supported
 */
export const getRobotIdsWithTasks = createSelector(
  (state: AppState) => state.workspaceResources.activityTemplates.byId,
  (state: AppState) => state.workspaceResources.activityTemplates.allIds,
  (robots, ids): string[] =>
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ids.filter((id) => robots[id].config?.sourceType === 's3' && robots[id].config?.package?.tasks),
);

/**
 * Returns all available tasks
 */
export const getAvailableTasks = createSelector(
  (state: AppState) => state.workspaceResources.activityTemplates.byId,
  getRobotIdsWithTasks,
  (robots, ids): RobotTask[] => {
    const allTasks: RobotTask[] = [];
    ids.forEach((id) => {
      const robot = robots[id];
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const { tasks } = robot.config.package;
      const taskNames = Object.keys(tasks);
      taskNames.forEach((taskName) => {
        allTasks.push({
          robotName: robot.name,
          robotId: robot.id,
          taskName,
        });
      });
    });

    return allTasks;
  },
);
